export const css = {
	root: '_1GnvPyNs',
	' _key': 'ascm-theme/ascm/variants/cltd2024ss'
};

export default css;
